import { Account, AccountType } from "../graphql";

export type ShortAccount = {
  profile?: {
    __typename?: "ClientProfile" | "DoctorProfile" | "SystemUserProfile";
    name?: string;
    lastname?: string;
  };
};

export const getFullName = (account: ShortAccount) => {
    if (!account) {
        return "";
    }

    if (
    account.profile?.__typename === AccountType.SystemUserProfile ||
    account.profile?.__typename === AccountType.ClientProfile ||
    account.profile?.__typename === AccountType.DoctorProfile
    ) {
        const { name, lastname } = account?.profile;

        return `${name} ${lastname}`;
    }

    return "";
};
